import { useEffect } from 'react';
import { useFixedPM2HeaderWhileRefIsInView } from '@pm2/react-utils';
import { modalSelectors } from '@ui/kit/selectors';
import { findNearestScroller, getAbsoluteNodeOffset } from '@utils/common';
import { applyCssDeclarations } from '@utils/css';
import { useIntersectionObserver } from '@utils/react';
import { tokens } from './molecule.content.style.js';

/**
 * Frustratingly position: sticky does not work if an element has an ancestor
 * with overflow: auto. This will always be the case for our dropzones and they
 * need to have sticky headers. As such we must resort to a JS implementation.
 */
function useStickyHeader(wrapperRef, contentRef, enabled) {
  const isInView = useIntersectionObserver(wrapperRef);
  useFixedPM2HeaderWhileRefIsInView(wrapperRef, enabled);
  useEffect(() => {
    const wrapper = wrapperRef.current;
    const content = contentRef.current;
    if (!wrapper || !content || !isInView || !enabled) {
      return;
    }
    const scroller = findNearestScroller(wrapper, "vertical");
    const onScroll = () => {
      const offsetTop = getAbsoluteNodeOffset(wrapper, document.querySelector(modalSelectors.scrollContainer())).y;
      const delta = Math.max(0, Math.min(wrapper.clientHeight - content.clientHeight - 82, (scroller?.scrollTop ?? window.scrollY) - offsetTop - 1));
      content.classList.toggle("sticky", delta > 0);
      applyCssDeclarations(tokens.offsetTop.__override(`${delta}px`), wrapper);
    };
    onScroll();
    (scroller ?? window).addEventListener("scroll", onScroll);
    return () => {
      (scroller ?? window).removeEventListener("scroll", onScroll);
    };
  }, [contentRef, enabled, isInView, wrapperRef]);
}

export { useStickyHeader };
//# sourceMappingURL=hook.sticky-header.js.map
